/**
 * Dừng Html5Qrcode an toàn — bắt AbortError khi <video> bị gỡ khỏi DOM
 * trong lúc play()/getUserMedia còn đang chạy (đóng Dialog, đổi "Nhập tay",
 * điều hướng trang). Không để Promise reject lọt ra Uncaught runtime errors.
 */
async function dungScannerAnToan(qr) {
  if (!qr) return;
  try {
    if (typeof qr.isScanning === "boolean" ? qr.isScanning : true) {
      await qr.stop();
    }
  } catch {
    // Đã dừng / DOM đã mất — bỏ qua
  }
  try {
    if (typeof qr.clear === "function") {
      qr.clear();
    }
  } catch {
    // clear() có thể fail nếu element đã unmount
  }
}

/** Có phải lỗi "play() bị gián đoạn vì media bị gỡ khỏi document" không. */
function laLoiPlayBiGianDoan(lyDo) {
  if (!lyDo) return false;
  if (lyDo.name === "AbortError") return true;
  const msg = String(lyDo.message || lyDo);
  return (
    msg.includes("play()") ||
    msg.includes("interrupted") ||
    msg.includes("removed from the document") ||
    msg.includes("The play() request was interrupted")
  );
}

/**
 * Chặn CRA error overlay / Uncaught runtime errors cho AbortError của camera.
 * Gọi 1 lần lúc boot app (index.js).
 */
function caiDatBoLocLoiCamera() {
  if (typeof window === "undefined") return;
  if (window.__thumuaBoLocLoiCamera) return;
  window.__thumuaBoLocLoiCamera = true;

  window.addEventListener("unhandledrejection", (event) => {
    if (laLoiPlayBiGianDoan(event.reason)) {
      event.preventDefault();
    }
  });
}

/** html5-qrcode yêu cầu mỗi cạnh qrbox ≥ 50px — khung camera nhỏ (mobile/dialog) dễ tính ra dưới ngưỡng. */
const QRBOX_TOI_THIEU = 50;

function tinhQrBox(rongKhungHinh, caoKhungHinh) {
  const canhToiDa = Math.min(Number(rongKhungHinh) || 0, Number(caoKhungHinh) || 0);
  const canh = Math.floor(canhToiDa * 0.7);
  const canhAnToan = Math.max(QRBOX_TOI_THIEU, Math.min(canh, canhToiDa || QRBOX_TOI_THIEU));
  return { width: canhAnToan, height: canhAnToan };
}

export { dungScannerAnToan, laLoiPlayBiGianDoan, caiDatBoLocLoiCamera, tinhQrBox };
